<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <span class="cookie_bar__text">{{$t('cookies.description')}}</span>
                <button class="button--cta has-margin-bottom" @click="confirm">{{ $t('cookies.confirm') }}</button>
                <button class="button has-smaller-horizontal-padding">{{$t('cookies.more_information')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';

    @Component
    export default class CookieBanner extends Vue {
        name = 'cookie-banner';

        confirm() {
            this.$emit('confirm');
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/cookies/CookieBanner.vue